import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import './assets/designTokens.css';
import store from './store/store';
import { Provider } from 'react-redux';
// import * as serviceWorker from './serviceWorker';

import { BrowserRouter, Route, Switch, Redirect, Link } from "react-router-dom";
import AuthLayout from "./layouts/AuthLayout.jsx";
import AdminLayout from "./layouts/AdminLayout.jsx";
import {PrivateRoute} from './PrivateRoute';

import CetakKutipanSuratKetetapanPajak from "./layouts/CetakKutipanSuratKetetapanPajak.jsx";
import CetakStnk from "./layouts/CetakStnk.jsx";
import SuratFiskal from "./layouts/SuratFiskal.jsx";

import NotaPajak from "./views/laporan/NotaPajak.jsx";
import BendaharawanKhususPenerimaanPajakBbnkb from "./views/laporan/BendaharawanKhususPenerimaanPajakBbnkb.jsx";
import LapNoticePrint from "./views/laporan/LapNoticePrint.jsx";
import LapNoticeRusakPrint from "./views/laporan/LapNoticeRusakPrint.jsx";
import LapPenggunaanNoticeRusakPrint from "./views/laporan/LapPenggunaanNoticeRusakPrint.jsx";

import LapKasirCetak from "./views/laporan/LapKasirCetak.jsx";
import LapTellerCetak from "./views/laporan/LapTellerCetak.jsx";
import LapPerRekeningCetak from "./views/laporan/LapPerRekeningCetak.jsx";

import LapCetakStnkCetak from "./views/laporan/LapCetakStnkCetak.jsx";
import LapBendaharaPenerimaanCetak from "./views/laporan/LapBendaharaPenerimaanCetak.jsx";
import LapPenetapanPkbCetak from "./views/laporan/LapPenetapanPkbCetak.jsx";
import LapPenerimaanPkbWarnaPlatCetak from "./views/laporan/LapPenerimaanPkbWarnaPlatCetak.jsx";
import LapSUM32Cetak from "./views/laporan/LapSum32Cetak.jsx";

import LapStssCetak from "./views/laporan/LapStssCetak.jsx";
import StsHarianCetak from "./views/laporan/StsHarianCetak.jsx";
import StsOpsenHarianCetak from "./views/laporan/StsOpsenHarianCetak.jsx";
import StsSP3HarianCetak from "./views/laporan/StsSP3HarianCetak.jsx";
import StsEdcHarianCetak from "./views/laporan/StsEdcHarianCetak.jsx";
import StsOpsenEdcHarianCetak from "./views/laporan/StsOpsenEdcHarianCetak.jsx";

import LaporanPnbpCetak from "./views/laporan/LaporanPnbpCetak.jsx";

import PemutihanCetak from "./views/laporan/PemutihanCetak.jsx";


import {
  Result,
  Button,
  ConfigProvider,
  message,
} from 'antd';

import LapSwdklljCetak from './views/laporan/LapSwdklljCetak';
import VerifikasiSlip from './views/publik/VerifikasiSlip';

// Toast (message) direposisi ke pojok kanan atas, di bawah header fixed
// (72px, lihat style.css .header) - posisi & poles visualnya lengkap di
// assets/designTokens.css (.ant-message*). Ini cuma offset vertikal resmi
// lewat API message.config, berlaku global untuk semua message.* di
// seluruh aplikasi tanpa perlu ubah pemanggilannya satu per satu.
message.config({ top: 88, maxCount: 3 });

// import { initializeFirebase } from './push-notification';
ReactDOM.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#1890ff',
        colorError: '#ff4d4f',
        colorSuccess: '#52c41a',
        colorWarning: '#faad14',
        fontFamily: 'Rubik, sans-serif',
        borderRadius: 6,
        controlHeight: 32, // contoh tambahan untuk ukuran input/button
      },
    }}
  >

    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/auth" component={AuthLayout} />

          <PrivateRoute path="/admin" component={AdminLayout} />
          
          <PrivateRoute exact path="/addon/cetak_kutipan_skp/:id" component={CetakKutipanSuratKetetapanPajak} />
          <PrivateRoute exact path="/addon/cetak_stnk/:id" component={CetakStnk} />
          <PrivateRoute exact path="/addon/surat_fiskal/:id" component={SuratFiskal} />
          {/* <PrivateRoute exact path="/addon/surat_fiskal/:id/?is_fiskal=true" component={SuratFiskal} /> */}

          <PrivateRoute exact path="/laporan/harian-nota-pajak" component={NotaPajak} />
          <PrivateRoute exact path="/laporan/bbnkb-pkb" component={BendaharawanKhususPenerimaanPajakBbnkb} />
          <PrivateRoute exact path="/laporan/notice" component={LapNoticePrint} />
          <PrivateRoute exact path="/laporan/notice-rusak" component={LapNoticeRusakPrint} />
          <PrivateRoute exact path="/laporan/penggunaan-notice-rusak" component={LapPenggunaanNoticeRusakPrint} />
          <PrivateRoute exact path="/laporan/kasir" component={LapKasirCetak} />
          <PrivateRoute exact path="/laporan/teller" component={LapTellerCetak} />
          <PrivateRoute exact path="/laporan/swdkllj" component={LapSwdklljCetak} />
          <PrivateRoute exact path="/laporan/perekening" component={LapPerRekeningCetak} />
          <PrivateRoute exact path="/laporan/cetak-stnk" component={LapCetakStnkCetak} />
          <PrivateRoute exact path="/laporan/bendahara-penerimaan" component={LapBendaharaPenerimaanCetak} />
          <PrivateRoute exact path="/laporan/harian-pkb" component={LapPenetapanPkbCetak} />
          <PrivateRoute exact path="/laporan/harian-sum32" component={LapSUM32Cetak} />
          
          <PrivateRoute exact path="/laporan/penerimaan-pkb-warna" component={LapPenerimaanPkbWarnaPlatCetak} />
          <PrivateRoute exact path="/laporan/stss" component={LapStssCetak} />

          <PrivateRoute exact path="/laporan/sts-harian" component={StsHarianCetak} />
          <PrivateRoute exact path="/laporan/sts-opsen-harian" component={StsOpsenHarianCetak} />
          <PrivateRoute exact path="/laporan/sts-sp3-harian" component={StsSP3HarianCetak} />
          <PrivateRoute exact path="/laporan/sts-edc-harian" component={StsEdcHarianCetak} />
          <PrivateRoute exact path="/laporan/sts-opsen-edc-harian" component={StsOpsenEdcHarianCetak} />
          

          <PrivateRoute exact path="/laporan/pnbp" component={LaporanPnbpCetak} />

          <PrivateRoute exact path="/laporan/pemutihan" component={PemutihanCetak} />

          <Route exact path="/verifikasi/slip/:ref" component={VerifikasiSlip} />

          <Route from="/" render={() => <Redirect to="/admin/index"/>}/>{/*live server must off*/}
          <Route path="" render={
              () => 
                  <Result
                      status="404"
                      title={
                        <div>
                        404
                        </div>
                      }
                      subTitle={
                        <div>
                          <h1>Maaf, halaman tidak ditemukan</h1><br />
                          <img src={process.env.PUBLIC_URL + "/icon.svg"} height="50" /><br /><br />
                          <Link to="/">
                            <Button type="primary">
                              kembali ke halaman utama
                            </Button>
                          </Link>
                        </div>
                      }
                  />
          } />
        </Switch>
      </BrowserRouter>
    </Provider>,
  </ConfigProvider>,
  document.getElementById('root')
);

// initializeFirebase();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
